import { gql } from '@apollo/client';

import { lessonFragment } from '../fragments';

export default gql`
  query GetLesson($courseId: String!, $groupId: String!, $lessonId: String!) {
    lesson(courseId: $courseId, groupId: $groupId, lessonId: $lessonId)
      @rest(
        type: "Lesson"
        path: "courses/{args.courseId}/groups/{args.groupId}/lessons/{args.lessonId}"
      ) {
      ...Lesson
    }
  }
  ${lessonFragment}
`;
